import React, {Component} from 'react';
import ImageAPI from "../classes/ImageAPI";
import Favourite from "./Favourite";
import VenueImage from "./VenueImage";
import { Trans } from 'react-i18next';
import Icon from "./Icon";

class SearchResult extends Component {
  constructor(props) {
    super(props);
    let {result} = this.props;
    this.state = {image: null};
    this.imageAPI = new ImageAPI();
    // this.imageAPI.embedMedia(result.field_keyvisual.attributes.drupal_internal__mid, 'contact_block').then((results) => this.setState({image: results}))
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let {result} = this.props;
    if (!this.state.image) {
      // this.imageAPI.embedMedia(result.field_keyvisual.attributes.drupal_internal__mid, 'contact_block').then((results) => this.setState({image: results}))
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({image: null});
  }

  render() {
    let {result} = this.props;
    let venue_types = [];
    result.field_venue_type.map((venue_type, index) => {
      venue_types.push((
        <span key={index}
              className="label">
          {venue_type.attributes.name}
        </span>
      ))
    });
    const capacity = result.field_capacity;

    // {result.field_venue_type[0].attributes.name}
    return (
      <article className="teaser teaser--venue"
               data-aos="fade-up">
        <div className="teaser__inner">
          <div className="teaser__content">
            <h3 className="teaser__title">
              <a href={drupalSettings.path.baseUrl + (result.path && result.path.alias ? result.path.alias.replace(/^\//, '') : "node/" + result.drupal_internal__nid)}
                 className="teaser__link">
                {result.title}
              </a>
            </h3>
            <div className="teaser__labels labels">
              {venue_types}
            </div>
            <div className="teaser__meta">
              <div className="teaser__capacity">
                <Icon iconId="users"/>
                <Trans i18nKey="search_result.venue_label_capacity" capacity={capacity}>Up to {{capacity}} people</Trans>
              </div>
              {/*{result.field_preferred_partner &&*/}
              {/*  <div className="teaser__preferred"*/}
              {/*    <Icon iconId="users"/>*/}
              {/*    <Trans i18nKey="search_result.venue_label_preferred">Preferred partner</Trans>*/}
              {/*  </div>*/}
              {/*}*/}
              {result.field_sustainable &&
                <div className="teaser__sustainable">
                  <Icon iconId="leaf"/>
                  <Trans i18nKey="search_result.venue_label_sustainable">Sustainable</Trans>
                </div>
              }
            </div>
          </div>
          <div className="teaser__visual">
            <Favourite nid={result.drupal_internal__nid}/>
            <div className="teaser__image">
              <VenueImage mid={result.field_keyvisual.attributes.drupal_internal__mid}/>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

export default SearchResult;
